import type { ShippingLabelViewModel } from "@/modules/chat-tools/domain/build-shipping-label";
import { ShippingLabelCard } from "@/modules/chat-tools/presentation/ui/ShippingLabelCard";
import { createRoot, type Root } from "react-dom/client";

export type MountedShippingLabel = {
  element: HTMLElement;
  unmount: () => void;
};

export async function mountShippingLabelElement(
  label: ShippingLabelViewModel,
): Promise<MountedShippingLabel> {
  const host = document.createElement("div");
  host.style.position = "fixed";
  host.style.left = "-10000px";
  host.style.top = "0";
  host.style.pointerEvents = "none";
  host.style.opacity = "0";
  document.body.appendChild(host);

  const mountPoint = document.createElement("div");
  host.appendChild(mountPoint);

  let root: Root | null = createRoot(mountPoint);

  root.render(<ShippingLabelCard label={label} />);

  await new Promise<void>((resolve) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => resolve());
    });
  });

  const element =
    mountPoint.firstElementChild instanceof HTMLElement
      ? mountPoint.firstElementChild
      : mountPoint;

  return {
    element,
    unmount: () => {
      root?.unmount();
      root = null;
      host.remove();
    },
  };
}
